import { gsap } from "gsap";

export default function(val) {
  const scrollButton = gsap.timeline();
  const delayVal = () => val === null ? 5.5 : 0.5;


  if (window.matchMedia("(min-width: 770px)").matches) {
    const top01 = 20;
    const set01 = top01 + 20;
    scrollButton.set(".buttonScrollDown", { bottom: set01, opacity: 0 });

    scrollButton.to(".buttonScrollDown", {
      delay: delayVal(),
      opacity: 1,
      duration: 1,
    });

    scrollButton.to(".buttonScrollDown", {
      duration: 1,
      bottom: top01,
      yoyo: true,
      repeat: -1,
      ease: "power1.inOut"
    });
  } else {
    const top01 = '120vw';
    const set01 = '126vw';
    scrollButton.set(".buttonScrollDown", { top: set01, opacity: 0 });

    scrollButton.to(".buttonScrollDown", {
      delay: delayVal(),
      opacity: 1,
      duration: 1,
    });

    scrollButton.to(".buttonScrollDown", {
      duration: 1,
      top: top01,
      yoyo: true,
      repeat: -1,
      ease: "power1.inOut"
    });
  }
}
